import { niceCheckDecode } from '@Views/utils/ServiceUtils';
import { getParameterByName, isEmpty } from '@Views/utils/StringUtils';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import SignInPage1 from './comp/SignInPage1';
import SignInPage2 from './comp/SignInPage2';
import SignInPage3 from './comp/SignInPage3';

const SignIn = ({ msg }: any) => {

  const [signPageNo, setSignPageNo] = useState<number>(1);
  const [chooseOption, setChooseOption] = useState<boolean>(false);
  const [niceInfo, setNiceInfo] = useState<any>();
  const history = useHistory();

  const niceInfoCheck = async () => {
    const win: any = window;
    const encodeData: any = getParameterByName("EncodeData");

    if (isEmpty(niceInfo)) {
      if (win.opener) {
        win.opener.location = win.location.href;
        win.close();
      } else {
        if (isEmpty(encodeData) === false) {
          const info = await niceCheckDecode(encodeData);

          let writer14Under = localStorage.getItem('writer14Under');

          if (isEmpty(writer14Under) === false) {
            info['guardian'] = info['name'];
            info['name'] = writer14Under;
          }

          if (info) {
            setNiceInfo(info);
          }
        } else {
          history.goBack();
        }
      }
    }
  }

  useEffect(() => {
    niceInfoCheck();
  }, [])
  return (
    <>
      {
        signPageNo === 1 ?
          <SignInPage1 msg={msg} history={history} setSignPageNo={setSignPageNo} setChooseOption={setChooseOption} />
          :
          signPageNo === 2 ? <SignInPage2 msg={msg} setSignPageNo={setSignPageNo} niceInfo={niceInfo} chooseOption={chooseOption} />
            :
            signPageNo === 3 && <SignInPage3 msg={msg} history={history} setSignPageNo={setSignPageNo} />
      }
    </>
  );
}
export default SignIn;